// extracted by mini-css-extract-plugin
export default {"icon":"T4a70IQ_"};